import React, { FC, useContext, useEffect, useState } from 'react';
import SkillOverviewCard from '../skill-overview-card';
import { AccountContext, AccountContextInterface } from '../../../../contexts';
import ProfilePicture from '../../../../components/profile-picture';
import { Account } from '../../../../models';
import { UserSkill } from '../../../../models/skill.model';
import { Tab } from '../../../../types';

type SidebarProps = {
  accountId: string;
  onSkillClick: (skill: UserSkill, type: Tab.Creds | Tab.Reccos) => void;
};

const Sidebar: FC<SidebarProps> = ({ accountId, onSkillClick }) => {
  const { accountService } = useContext<AccountContextInterface>(AccountContext);
  const [loading, setLoading] = useState<boolean>(true);
  const [account, setAccount] = useState<Account>();

  useEffect(() => {
    const fetchAccount = async () => {
      try {
        setLoading(true);
        const { data } = await accountService.getAccount(accountId);
        setAccount(data);
      } catch (error) {
        console.log(error);
      } finally {
        setLoading(false);
      }
    };

    fetchAccount();
  }, [accountId, accountService]);

  return (
    <div className="w-full md:h-[100vh] lg:h-[100vh] md:w-96 p-4 bg-white">
      {loading ? (
        <>
          <div className="flex items-center space-x-3 mb-4 animate-pulse">
            <div className="w-12 h-12 rounded-full bg-gray-200" />
            <div>
              <div className="w-32 h-4 bg-gray-200 rounded mb-2"></div>
              <div className="w-48 h-3 bg-gray-200 rounded"></div>
            </div>
          </div>
          <div className="flex justify-between items-center text-center mb-6 animate-pulse">
            {[1, 2, 3].map((_, i) => (
              <div key={i}>
                <div className="w-8 h-4 bg-gray-200 rounded mb-1 mx-auto"></div>
                <div className="w-12 h-3 bg-gray-200 rounded mx-auto"></div>
              </div>
            ))}
          </div>
          <div className="w-full h-10 bg-gray-200 rounded-full mb-6 animate-pulse"></div>
          <div className="w-full h-32 bg-gray-200 rounded animate-pulse"></div>
        </>
      ) : (
        <>
          <div className="flex items-center space-x-3 mb-4">
            <div className="w-14 h-14">
              <ProfilePicture name={account?.displayName || 'U'} url={account?.profilePictureResource?.url} />
            </div>
            <div>
              <h2 className="text-lg font-bold">{account?.displayName}</h2>
              <p className="text-sm text-gray-600">{account?.bio || 'Interested in something awesome!'}</p>
            </div>
          </div>
          <div className="flex justify-between items-center text-center mb-6">
            <div>
              <h3 className="text-lg font-bold">{account?.famsCount || 0}</h3>
              <p className="text-sm text-gray-500">Fam</p>
            </div>
            <div>
              <h3 className="text-lg font-bold">{account?.followersCount || 0}</h3>
              <p className="text-sm text-gray-500">Followers</p>
            </div>
            <div>
              <h3 className="text-lg font-bold">{account?.followingsCount || 0}</h3>
              <p className="text-sm text-gray-500">Following</p>
            </div>
          </div>
          <a href={process.env.REACT_APP_RECCO_MARKETING_URL}>
            <button className="w-full bg-blue-500 text-white py-2 rounded-full mb-6 hover:bg-blue-600 transition">Follow</button>
          </a>
          <SkillOverviewCard accountId={accountId} onSkillClick={onSkillClick} />
        </>
      )}
    </div>
  );
};

export default Sidebar;
